import React from 'react';
import { IRifa } from '../../types/rifa';
import GarantiaRifaTech from './GarantiaRifaTech';
import CapaRifaCancelada from './CapaRifaCancelada';

interface Props {
   rifa: IRifa,
   loading?: boolean,
}

const RifaCancelada: React.FC<Props> = ({ rifa, loading }: Props) => {
   return (
		<div>
         <CapaRifaCancelada 
            rifa={rifa} 
            loading={loading} />
         <GarantiaRifaTech />
		</div>
   );
}

export default RifaCancelada;